import * as React from 'react';
import PropTypes from 'prop-types';

const SvgNavigationGroupNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M15.29 8.95l-.66-1.25a2.256 2.256 0 00-2-1.2H9.32a2.268 2.268 0 00-2 1.2l-.43.82a.974.974 0 00-.24-.02H3.34a2.256 2.256 0 00-2 1.2l-.66 1.24a1.735 1.735 0 001.54 2.56h5.54a1.742 1.742 0 001.66-2.27c-.03-.09-.91-1.76-1-1.86a2.025 2.025 0 00-.57-.52l.36-.68a1.257 1.257 0 011.11-.67h3.31a1.272 1.272 0 011.12.67l.65 1.24a.708.708 0 01-.02.73.726.726 0 01-.63.36h-3.59l.55 1h3.04a1.739 1.739 0 001.54-2.55zM8.4 12.14a.73.73 0 01-.64.36H2.22a.743.743 0 01-.66-1.09l.66-1.24a1.272 1.272 0 011.12-.67h3.31a1.269 1.269 0 011.11.67l.65 1.24a.732.732 0 01-.01.73zm2.57-7.64a2 2 0 100-4 2 2 0 000 4zm0-3a1 1 0 110 2 1 1 0 010-2zM5 7.5a2 2 0 100-4 2 2 0 000 4zm0-3a1 1 0 110 2 1 1 0 010-2z"
        fill=""
      />
    </svg>
  )
);
SvgNavigationGroupNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgNavigationGroupNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgNavigationGroupNormalXsmall;
